import React, { Component, Fragment } from 'react';
import NotificationSystem from 'react-notification-system';
import PropTypes from "prop-types";
import { BeatLoader } from 'react-spinners';
import ReactTable from 'react-table';
import { _addNotification, _addNotificationError, getSchoolGrades } from '../../../server/util';
import { get, postWithHeaders } from '../../../server/actions';
import checkboxHOC from "react-table/lib/hoc/selectTable";
import _, { first, groupBy } from 'lodash';
import $ from "jquery";
import { Header } from 'react-bootstrap/lib/Modal';

const CheckboxTable = checkboxHOC(ReactTable);
let gradeList = [];

class NotSubmitStudents extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            notSubmStudentData: [],
            selectAll: false,
            selection: [],
            selectionStuList: {},
            nonSubmitUsers: [],

            data: [],
            filterData: [],
            search: ''
        }
    }

    cols = [
        {
            Header: 'StudentId',
            accessor: 'studentId',
            width: 200,
            style: { textAlign: 'center' }
        },
        {
            Header: 'Name',
            accessor: 'stName',
            width: 200,
            style: { textAlign: 'center' },

        },
        {
            Header: 'Grade',
            accessor: 'grade',
            width: 200,
            style: { textAlign: 'center' }
        },
    ];
    componentDidMount() {
        this._notificationSystem = this.refs.notificationSystem;
        this.getNotSubmitStudentData();
    }
    getNotSubmitStudentData = () => {
        let userInfo = JSON.parse(sessionStorage.getItem('loggedInUserInfo'));
        let schoolId = userInfo.schoolId;
        this.setState({ loading: true })
        get(`/eseaForms/students/${schoolId}/${sessionStorage.getItem('schoolYearValue')}?isNotSubmittedESEA=true&access_token=`).then((resp) => {
            this.setState({ loading: false });
            console.log("Response:::::", resp);
            if (!resp.ok) {
                throw Error(resp.statusMessage);
            }
            return resp.json();
        }).then(data => {
            const response = data.resp;
            const parentGroup = groupBy(response, 'username');
            const _data = Object.keys(parentGroup).map(parentEmail => {
                return {
                    username: parentEmail, studentList: (parentGroup[parentEmail] || []).map(st => {
                        return { ...st, stName: st.firstName + " " + st.lastName }
                    })
                }
            })
            this.setState({
                data: _data,
                filterData: _data
            });
        }).catch(
            (error) => {
                this.setState({ loading: false });
                console.log('notSubmStudentData', error);
            }
        )
    }
    filterRecords = () => {
        this.setState({
            filterData: this.state.data.filter(r => {
                return (r.username || '').length == 0 ? true : (r.username || '').toLowerCase().startsWith(this.state.search.toLowerCase());
            })
        });
    }


    getColumns = () => {
        return [
            {
                Header: 'Parent Email Id',
                accessor: 'username',
                width: 200,
                style: { textAlign: 'left' }
            },
            {
                Header: 'Students',
                id: 'students',
                Cell: (row) => {
                    const { original } = row;
                    const { studentList } = original;
                    return (
                        <div className='row'>
                            <div className='col-md-12'>
                                <table className='table table-sm table-bordered'>
                                    <thead>
                                        <tr>
                                            {this.cols.map(col => {
                                                return <th>{col.Header}</th>
                                            })}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            (studentList || []).map(st => {
                                                return <tr>
                                                    {
                                                        this.cols.map(col => {
                                                            return <td>{st[col.accessor]}
                                                            </td>
                                                        })
                                                    }
                                                </tr>
                                            })

                                        }
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    );
                }
            }

        ]
    }


    toggleSelection = (key, shift, row) => {
        //alert('selection')
        // alert(key)
        let selection = [...this.state.selection];
        let selectionStuList = this.state.selectionStuList
        const keyIndex = selection.indexOf(key);
        // check to see if the key exists
        if (keyIndex >= 0) {
            // it does exist so we will remove it using destructing
            selection = [
                ...selection.slice(0, keyIndex),
                ...selection.slice(keyIndex + 1)
            ];
            delete selectionStuList[key];
        } else {
            // it does not exist so add it
            selection.push(key);
            selectionStuList[key] = { username: row.username }
        }
        // update the state
        this.setState({ selectAll: false, selection: selection, selectionStuList: selectionStuList });

        // console.log("selection:", this.state.selection);
    };
    toggleAll = () => {
        //alert('toggleAll')
        const selectAll = this.state.selectAll ? false : true;
        const selection = [];
        let selectionStuList = {}
        if (selectAll) {
            // we need to get at the internals of ReactTable
            const wrappedInstance = this.checkboxTable.getWrappedInstance();
            // the 'sortedData' property contains the currently accessible records based on the filter and sort
            const currentRecords = wrappedInstance.getResolvedState().sortedData;
            //this.setState({studentCount: currentRecords.length});
            // we just push all the IDs onto the selection array
            //console.log(JSON.stringify(currentRecords,null,2))
            currentRecords.forEach(item => {
                selection.push(item._original.username);
                selectionStuList[item._original.username] = { username: item._original.username }
            });
        }
        this.setState({ selectAll, selection, selectionStuList });
    };
    isSelected = key => {
        const res = (this.state.selection || []).find((item) => {
            const _item = ((item || '') + '').replace('select-', '');
            return _item == key;
        });
        if (res) {
            return true;
        } else {
            return false;
        }
    };

    render() {
        gradeList = getSchoolGrades();
        const { toggleSelection, toggleAll, isSelected } = this;
        const { data, selectAll } = this.state;
        const checkboxProps = {
            selectAll,
            isSelected,
            toggleSelection,
            toggleAll,
            selectType: "checkbox",

            getTheadProps: () => {
                return {
                    style: {
                        backgroundColor: "#D2D7D4", fontWeight: 'bold'
                        // color: selected ? 'white' : 'inherit',
                    },
                    className: "bg-success base-reverse"
                };
            },
            getTableProps: () => {
                return {
                    className: "table table-hover"
                }
            }
        };
        {
            $('#selector button').click(function () {
                $(this).addClass('active').siblings().removeClass('active');
                // TODO: insert whatever you want to do with $(this) here
            })
        }
        return (
            <div>
                <NotificationSystem ref="notificationSystem" />
                <div className='sweet-loading' style={{ position: 'fixed', top: '50%', left: '48%', zIndex: '1000   ' }}>
                    <BeatLoader
                        size={20}
                        color={'#ea7066'}
                        loading={this.state.loading}
                    />
                </div>
                <div className="row" style={{ marginBottom: '5px' }}>
                    <div className='col-md-3'>
                        <input type="text" id="search"
                            className="form-control"
                            name="search"
                            placeholder="Search.."
                            onChange={(e) => {
                                this.setState({ search: e.target.value }, () => {
                                    this.filterRecords();
                                })
                            }} />

                    </div>
                    <div className='col-md-9'>
                        <button className="btn btn-sm pull-right btn-danger" style={{ margin: '0px' }} type="button" onClick={(e) => {
                            if ((Object.keys(this.state.selectionStuList)).length <= 0) {
                                _addNotificationError('Please select atleast one record.', this);
                                return false;
                            } else {
                                let schoolId = sessionStorage.getItem('SchoolId');
                                let headers = {
                                    'Content-Type': 'application/json',
                                    // responseType: "blob"
                                };
                                const resp = [];
                                const selectedList = data.filter(r => Object.keys(this.state.selectionStuList).includes(r.username));
                                selectedList.map(rec => {
                                    rec.studentList.map(s => {
                                        resp.push(s.studentId);
                                    })
                                });
                                const url = `/eseaForms/dueNotification/${schoolId}/${sessionStorage.getItem('schoolYearValue')}?access_token=`
                                postWithHeaders(url, JSON.stringify(resp), headers).then((response) => {
                                    if (!response.ok) {
                                        throw Error(response.statusText);
                                    }
                                    return response.json();
                                }).then((data) => {
                                    _addNotification('ESEA form filling due notification has been successfully sent!!', this);
                                    this.getNotSubmitStudentData();
                                    this.setState({ selectAll: false, selectionStuList: {}, selection: [] });
                                }).catch(
                                    (error) => {
                                        this.setState({ loading: false })
                                        _addNotificationError('Failed to download file ! Try again.', this);
                                        console.log('Send Notification Error', error)
                                    }
                                );

                            }
                        }}>
                            <i className="fa fa-share-square-o" aria-hidden="true"></i> Send Notification
                        </button>
                    </div>
                </div>
                <div className="row">
                    <div className='col-md-12'>
                        <CheckboxTable
                            keyField="username"
                            expandedRows={true}
                            ref={r => (this.checkboxTable = r)}
                            data={this.state.filterData}
                            columns={this.getColumns()}
                            defaultPageSize={3}
                            className="-striped -highlight"
                            {...checkboxProps}

                        />
                    </div>
                </div>
            </div>
        );
    }
}

export default NotSubmitStudents;


// WEBPACK FOOTER //
// ./src/components/SchoolAdmin/EseaForm/notSubmitStudents.js